import styled, { css } from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';
import { Body } from '../../styled components/Typography';
import Button from '../Button/Button';
import tailwindConfig from '../../../tailwind.config';

export const Header = styled.div.attrs(() => ({
  'data-type': 'PageHeader'
}))(({ $fixed }) => [
  tw` bg-silver-lighten-30 border-b border-silver-darken-5`,
  $fixed ? tw`fixed top-0 min-w-full w-full z-1000` : tw`relative`
]);

export const HeaderContent = styled.div(() => [
  tw`container mx-auto break-words grid gap-8 items-center`,
  css`
    grid-template-areas: 'actionsleft title actionsright';
    grid-template-columns: 1fr fit-content(18ch) 1fr;
    height: ${tailwindConfig.extend.headerHeight / 16}rem;
  `
]);

export const HeaderTitle = styled(Body).attrs(() => ({
  as: 'div',
  $textStyle: 'bold'
}))(() => [
  tw`overflow-hidden text-ellipsis whitespace-nowrap`,
  css`
    grid-area: title;
  `
]);

export const HeaderTitleAnimation = styled(
  motion(Body, {
    forwardMotionProps: true
  })
).attrs(() => ({
  as: 'span',
  $textStyle: 'bold'
}))(() => []);

export const HeaderActionsLeft = styled.div(({ $paddingLeft }) => [
  tw`justify-self-start`,
  css`
    grid-area: actionsleft;
  `,
  !$paddingLeft && tw`pl-8`, // Default padding left
  $paddingLeft === 4 && tw`pl-4`,
  $paddingLeft === 16 && tw`pl-16`
]);

export const HeaderActionsRight = styled.div(({ $paddingRight }) => [
  tw`justify-self-end`,
  css`
    grid-area: actionsright;
  `,
  !$paddingRight && tw`pr-8`, // Default padding right
  $paddingRight === 12 && tw`pr-12`
]);

export const SettingsButton = styled(Button).attrs(() => ({
  contentType: 'textWithIcon',
  icon: 'settings',
  size: 'small',
  iconPosition: 'right'
}))(() => [tw`ml-4 mr-4`]);
